import { useGameStore } from '@/store/gameStore';
import { announce } from './announcer';
import { FREQUENCY_NAMES } from '@/types';

export function initGameAnnouncements(): void {
  useGameStore.subscribe((state, prevState) => {
    // Puzzle loaded
    if (state.puzzle && state.puzzle !== prevState.puzzle) {
      const p = state.puzzle;
      const board = p.board;
      announce(
        `Puzzle ${p.metadata.title}, Tier ${p.tier}. ${board.nodes.length} nodes, ${board.pathways.length} pathways. Strike budget: ${p.constraints.strikeBudget}.`
      );
    }

    // Strike happened
    if (state.lastStrikeResult && state.lastStrikeResult !== prevState.lastStrikeResult) {
      const result = state.lastStrikeResult;
      const struckNode = state.board?.nodes.find(n => n.id === result.struckNodeId);
      const noteName = struckNode ? (FREQUENCY_NAMES[struckNode.frequency] ?? '?') : '?';

      let msg = `Struck node ${result.struckNodeId}, frequency ${noteName}.`;

      for (const t of result.transmutations) {
        const oldName = FREQUENCY_NAMES[t.oldFrequency] ?? '?';
        const newName = FREQUENCY_NAMES[t.newFrequency] ?? '?';
        msg += ` Node ${t.nodeId} transmuted from ${oldName} to ${newName}.`;
      }

      announce(msg, 'assertive');
    }

    // Harmony update after strike
    if (state.harmonyReport && state.harmonyReport !== prevState.harmonyReport && state.lastStrikeResult) {
      const hr = state.harmonyReport;
      setTimeout(() => {
        announce(`${hr.satisfiedCount} of ${hr.totalPathways} pathways in harmony. ${hr.resonancePercentage}% resonance.`);
      }, 500);
    }

    // Win
    if (state.isComplete && !prevState.isComplete) {
      setTimeout(() => {
        announce('Resonance achieved!', 'assertive');
      }, 1000);
    }

    // Loss
    if (state.isLost && !prevState.isLost) {
      announce('Strikes exhausted. Press R to reset.', 'assertive');
    }
  });
}
